<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';

let globalId = 0;
export default defineComponent({
  name: 'OIconChevronRightSmall',
  svgType: 'fill',
  setup() {
    const classNames = ['o-svg-icon', 'o-icon-chevron-right-small', 'type-fill'];
    const isClient = ref(false);
    onMounted(() => {
      isClient.value = true;
    });
    return {
      isClient,
      classNames,
      globalId: globalId++,
    };
  },
});
</script>
<template>
  <svg viewBox="0 0 24 24" :class="classNames">
    <template v-if="isClient">
      <path d="M10.202 17.154a.56.56 0 0 1-.048-.736l.048-.056 4.008-4.016c.08-.08.096-.2.04-.296l-.04-.04-4.048-4.056a.565.565 0 0 1 0-.792c.2-.2.52-.216.736-.048l.056.048 4.048 4.056c.504.496.536 1.296.08 1.832l-.08.088-4.008 4.016a.565.565 0 0 1-.792 0"/>
    </template>
  </svg>
</template>